/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import isEqual from 'fast-deep-equal';
import { withRouter } from 'react-router-dom';
import api, { ignoreRequestFailure } from '../services/api';
import { withNurseryContext } from '../contexts/NurseryContext';
import PdpHeader from '../components/PlantDetail/pdpHeader';
import PdpNav from '../components/PlantDetail/pdpNav';
import PdpFacts from '../components/PlantDetail/pdpFacts';
import PdpSubmission from '../components/PlantDetail/pdpSubmission';
import PdpRelated from '../components/PlantDetail/pdpRelated';
import PdpDetails from '../components/PlantDetail/pdpDetails';
class DetailLayout extends React.Component {
    constructor(props) {
        var _a;
        super(props);
        this.headerValue = typeof window !== 'undefined' && ((_a = window.document.head.querySelector('meta[name="x-app-type"]')) === null || _a === void 0 ? void 0 : _a.getAttribute('content'));
        this.isSSR = this.headerValue === 'SSR';
        this.syncNurseryFromLocation = (locationSearch) => {
            const { setNurserySlug, setNurseryName } = this.props;
            const search = locationSearch || window.location.search || '';
            const querySearch = search.startsWith('?') ? search.substring(1) : search;
            const parsed = querySearch ? Object.fromEntries(new URLSearchParams(querySearch)) : {};
            const querySlug = parsed.nurseries || '';
            if (querySlug) {
                setNurserySlug(querySlug);
            }
            else {
                setNurserySlug('');
                setNurseryName('');
            }
            return querySlug;
        };
        this.setPDPData = (plantId, plantName, slugOverride) => {
            const { setNavigationData, setNurseryName, setNurserySlug, nurserySlug, } = this.props;
            const effectiveSlug = slugOverride !== undefined ? slugOverride : (nurserySlug || '');
            this.pendingSlug = effectiveSlug || undefined;
            const slugParam = effectiveSlug ? `?nursery=${effectiveSlug}` : '';
            api.plant.getPlants(`${plantId}/${plantName}/${slugParam}`).then((plantData) => {
                this.pendingSlug = undefined;
                if (effectiveSlug && plantData.nursery_name) {
                    setNurseryName(plantData.nursery_name);
                }
                else {
                    setNurseryName('');
                    setNurserySlug('');
                }
                if (effectiveSlug) {
                    setNavigationData(plantData.nursery_navigation);
                }
                else
                    setNavigationData(null);
                this.setState({ plantData });
            }).catch((err) => {
                this.pendingSlug = undefined;
                ignoreRequestFailure(err);
            });
        };
        this.state = {
            plantData: this.isSSR || typeof window === 'undefined' ? props.plantApiData : {
                alias: [],
                description: '',
                django_pk: 0,
                genus: '',
                get_plant_types: [],
                is_for_sale: false,
                plant_attr: [
                    {
                        attr_name: '',
                        attr_type: '',
                        attr_values: [
                            {
                                attr_pk_value: 0,
                                attr_value: '',
                            },
                        ],
                        pk_value: 0,
                    },
                ],
                plant_size: {
                    height: '',
                    width: '',
                },
                scientific_name: '',
                shopify_handle: '',
                shopify_product_id: 0,
                shopify_variants: [
                    {
                        available: false,
                        fulfillment_service: '',
                        handle: '',
                        id: '',
                        nursery: {
                            name: '',
                            shipping_info: '',
                        },
                        price: 0,
                        title: '',
                    },
                ],
                editorial_description: null,
                plantlust_description: {
                    contributor_info: {
                        avatar: '',
                        email: '',
                        is_nursery: false,
                        active: false,
                        location: {
                            address_line1: '',
                            address_line2: '',
                            city: '',
                            state: '',
                        },
                        name: '',
                        phone: '',
                        services: [],
                        slug: '',
                        url: '',
                    },
                    description_text: '',
                    is_photo: false,
                },
                submissions_descriptions: [
                    {
                        contributor_info: {
                            avatar: '',
                            email: '',
                            is_nursery: false,
                            active: false,
                            location: {
                                address_line1: '',
                                address_line2: '',
                                city: '',
                                state: '',
                            },
                            name: '',
                            phone: '',
                            services: [],
                            slug: '',
                            url: '',
                        },
                        description_text: '',
                        is_photo: false,
                        photo: '',
                        photo_id: -1,
                        source_host: '',
                        source_url: '',
                        tags: [],
                        websites: [],
                    },
                ],
                submissions_photos: [
                    {
                        contributor_info: {
                            avatar: '',
                            email: '',
                            is_nursery: false,
                            active: false,
                            location: {
                                address_line1: '',
                                address_line2: '',
                                city: '',
                                state: '',
                            },
                            name: '',
                            phone: '',
                            services: [],
                            slug: '',
                            url: '',
                        },
                        copyright_info: '',
                        is_photo: false,
                        photo: '',
                        photo_id: 0,
                        source_host: '',
                        source_url: '',
                        tags: [],
                        url: '',
                        alt: '',
                        websites: [],
                    },
                ],
                tags: [{
                        name: '',
                        slug: '',
                        url: '',
                    }],
                title: '',
                url: '',
                zones: [],
                nurseries: [
                    {
                        address: '',
                        description: '',
                        email: '',
                        name: '',
                        phone: '',
                        services: [],
                        slug: '',
                        url: '',
                        shop_url: '',
                    },
                ],
                related: {
                    genus: {
                        name: '',
                        slug: '',
                        url: '',
                    },
                    plant_count: 0,
                    plant_list: [
                        {
                            aka_names: [],
                            dimensions: {
                                H: '',
                                W: '',
                            },
                            django_pk: 0,
                            is_for_sale: false,
                            photo: '',
                            photo_webp: '',
                            photo_description: '',
                            plant_type: '',
                            primary_name: '',
                            slug: '',
                            sun_exposure: [],
                            variants: [],
                            water_needs: [],
                            zones_str: '',
                        },
                    ],
                },
                affiliated_links: [],
            },
        };
    }
    componentDidMount() {
        const { match, setNurseryName } = this.props;
        const { plantId, plantName } = match.params;
        const { plantData } = this.state;
        const querySlug = this.syncNurseryFromLocation();
        if (plantData === null || plantData === void 0 ? void 0 : plantData.nursery_name) {
            setNurseryName(plantData.nursery_name);
        }
        if (!(this.isSSR && (plantData === null || plantData === void 0 ? void 0 : plantData.django_pk))) {
            this.setPDPData(plantId, plantName, querySlug);
        }
    }
    shouldComponentUpdate(nextProps, nextState) {
        if (isEqual(this.state, nextState)
            && isEqual(this.props, nextProps)) {
            return false;
        }
        return true;
    }
    componentDidUpdate(prevProps) {
        const { nurserySlug, match, location } = this.props;
        const { plantData } = this.state;
        const locationChanged = !isEqual(prevProps.location, location);
        if (locationChanged) {
            const { plantId, plantName } = match.params;
            const querySlug = this.syncNurseryFromLocation(location.search);
            this.setPDPData(plantId, plantName, querySlug);
            return;
        }
        if (!(plantData === null || plantData === void 0 ? void 0 : plantData.nursery_name)
            && nurserySlug
            && prevProps.nurserySlug !== nurserySlug
            && this.pendingSlug !== nurserySlug) {
            const { plantId, plantName } = match.params;
            this.setPDPData(plantId, plantName, nurserySlug);
        }
    }
    render() {
        const { addToShopifyCart } = this.props;
        const { plantData } = this.state;
        const { shopify_variants: shopifyVariants, shopify_handle: shopifyHandle, title, alias, scientific_name: scientificName, is_for_sale: isForSale, affiliated_links: affiliatedLinks, nurseries: partnersData, django_pk: djangoPk, plantlust_description: plantlustDescription, editorial_description: editorialDescription, submissions_photos: photos, related: relatedData, } = plantData;
        const hasPhotos = photos.length > 0;
        return (React.createElement("div", { className: "pdp_container" },
            React.createElement("div", { className: "fullwidth_pdp_header" },
                React.createElement("div", { className: "container" },
                    React.createElement("div", { className: "pdp_header__container" },
                        React.createElement(PdpHeader, { djangoPk: djangoPk, shopifyVariants: shopifyVariants, shopifyHandle: shopifyHandle, addToShopifyCart: addToShopifyCart, title: title, plantlustDescription: plantlustDescription, editorialDescription: editorialDescription, alias: alias, scientificName: scientificName, photos: photos, isForSale: isForSale, plantData: plantData, partnersData: partnersData, affiliatedLinks: affiliatedLinks }),
                        React.createElement(PdpDetails, { plantData: plantData }),
                        React.createElement("div", null,
                            React.createElement(PdpNav, { hasPhotos: hasPhotos, hasMoreTypes: relatedData.plant_list.length > 0 }))))),
            React.createElement("div", { className: "fullwidth_pdp_submissions", id: "photo-gallery" },
                React.createElement("div", { className: "container" },
                    React.createElement(PdpSubmission, { data: photos, title: title }))),
            React.createElement("div", { className: "fullwidth_pdp_details", id: "plant-facts" },
                React.createElement("div", { className: "container" },
                    React.createElement(PdpFacts, { plantData: plantData }))),
            React.createElement("div", { className: "fullwidth_pdp_related", id: "more-types" },
                React.createElement("div", { className: "container" },
                    React.createElement(PdpRelated, { data: relatedData, addToShopifyCart: addToShopifyCart })))));
    }
}
export default withRouter(withNurseryContext(DetailLayout));
